import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import SearchLinksRepository from "repositories/SearchLinksRepository";
import { deserialize } from "utils/storeUtils";

const initialState = {
  searchLinks: null,
};

const searchLinksSlice = createSlice({
  name: "searchLinks",
  initialState,
  reducers: {
    getSearchLinks(state, { payload }) {
      state.searchLinks = deserialize(payload);
    },
  },
});

export const { actions } = searchLinksSlice;
export default searchLinksSlice.reducer;

export const useSearchLinksActions = () => {
  const dispatch = useDispatch();

  const getSearchLinks = () => {
    return SearchLinksRepository.getSearchLinks().then(({ data }) => {
      dispatch(searchLinksSlice.actions.getSearchLinks(data));
    });
  };

  return {
    getSearchLinks,
  };
};
